import React, {useState, useRef, useEffect} from 'react';
import './event-details.scss';
import TextField from '../../../../../components/form/textfield/textfield';
import ViewInfo from '../../components/view-info/view-info';
import {eventDetailInfoIconEnum} from '../../../../../utils/constants';
import AutoResizableTextArea from '../../../../../components/form/textArea/AutoResizeableTextArea';

const ProtectiveMeasure = ({
  readOnly,
  setProtectiveMeasuresHeight,
  setFieldValue,
  values,
}) => {
  const [firstTextFieldHeight, setFirstTextFieldHeight] = useState(0);
  const [secondTextFieldHeight, setSecondTextFieldHeight] = useState(0);
  const firstTextFieldRef = useRef(null);
  const secondTextFieldRef = useRef(null);
  const thirdTextFieldRef = useRef(null);

  // useEffect(() => {
  //   const resizeObserver = new ResizeObserver(() => {
  //     if (firstTextFieldRef.current) {
  //       setFirstTextFieldHeight(firstTextFieldRef.current.offsetHeight);
  //     }
  //     if (secondTextFieldRef.current) {
  //       setSecondTextFieldHeight(secondTextFieldRef.current.offsetHeight);
  //     }
  //     if (thirdTextFieldRef.current) {
  //       setProtectiveMeasuresHeight(thirdTextFieldRef.current.offsetHeight - 20);
  //     }
  //   });

  //   if (firstTextFieldRef.current)
  //     resizeObserver.observe(firstTextFieldRef.current);
  //   if (secondTextFieldRef.current)
  //     resizeObserver.observe(secondTextFieldRef.current);
  //   if (thirdTextFieldRef.current)
  //     resizeObserver.observe(thirdTextFieldRef.current);

  //   return () => {
  //     resizeObserver.disconnect();
  //   };
  // }, []);

  const rightElementStyles = {
    position: 'absolute',
    right: 25,
    top: 15,
  };

  return (
    <div style={{display:"flex",flexDirection:"column",gap:"1rem"}}>
      <div className="heading">Protective measures</div>

      <AutoResizableTextArea
        id="note-input"
        value={values['inherently_measures']}
        onChange={e => {
          setFieldValue('inherently_measures', e.target.value);
        }}
        // style={{
        //   overflow: 'hidden',
        // }}
        // ref={firstTextFieldRef}
        name="inherently_measures"
        label="Inherently Safe Design Measures"
        disabled={readOnly}
        placeholder="Inherently Safe Design Measures"
        rightElement={
          <ViewInfo
            label={
              eventDetailInfoIconEnum.protective_measure
                .inherently_safe_design_measure
            }
          />
        }
        rightElementStyles={rightElementStyles}
        // isMultiline={true}
      />

      {/* <TextField
        ref={firstTextFieldRef}
        name="inherently_measures"
        type="text"
        label="Inherently Safe Design Measures"
        disabled={readOnly}
        placeholder="Inherently Safe Design Measures"
        rightElement={
          <ViewInfo
            label={
              eventDetailInfoIconEnum.protective_measure
                .inherently_safe_design_measure
            }
          />
        }
        rightElementStyles={rightElementStyles}
        isMultiline={true}
      /> */}

      <div style={{marginTop: `${firstTextFieldHeight}px`}}>
        {/* <TextField
          ref={secondTextFieldRef}
          name="safeguarding"
          type="text"
          label="Safeguarding"
          disabled={readOnly}
          placeholder="Safeguarding"
          rightElement={
            <ViewInfo
              label={eventDetailInfoIconEnum.protective_measure.safeguarding}
            />
          }
          rightElementStyles={rightElementStyles}
          isMultiline={true}
        /> */}

        <AutoResizableTextArea
          id="note-input"
          value={values['safeguarding']}
          onChange={e => {
            setFieldValue('safeguarding', e.target.value);
          }}
          name="safeguarding"
          type="text"
          label="Safeguarding"
          disabled={readOnly}
          placeholder="Safeguarding"
          rightElement={
            <ViewInfo
              label={eventDetailInfoIconEnum.protective_measure.safeguarding}
            />
          }
          rightElementStyles={rightElementStyles}
          // style={{
          //   overflow: 'hidden',
          // }}
        />
      </div>

      <div
        style={{
          marginTop: `${secondTextFieldHeight}px`,
        }}>
        {/* <TextField
          name="info_for_use"
          type="text"
          ref={thirdTextFieldRef}
          label="Information for Use"
          disabled={readOnly}
          placeholder="Information for Use"
          rightElement={
            <ViewInfo
              label={
                eventDetailInfoIconEnum.protective_measure.information_for_use
              }
            />
          }
          rightElementStyles={rightElementStyles}
          isMultiline={true}
        /> */}

        <AutoResizableTextArea
          id="note-input"
          value={values['info_for_use']}
          onChange={e => {
            setFieldValue('info_for_use', e.target.value);
          }}
          name="info_for_use"
          type="text"
          label="Information for Use"
          disabled={readOnly}
          placeholder="Information for Use"
          rightElement={
            <ViewInfo
              label={
                eventDetailInfoIconEnum.protective_measure.information_for_use
              }
            />
          }
          rightElementStyles={rightElementStyles}
          // style={{
          //   overflow: 'hidden',
          // }}
        />
      </div>
    </div>
  );
};

export default ProtectiveMeasure;
